import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { PayPalCheckout } from "./PayPalCheckout";
import { CardCheckout } from "./CardCheckout";

export const QuickCheckout = ({ items, title, onClose }) => (
  <AnimatePresence>
    {items && (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          onClick={onClose}
          className="fixed inset-0 z-[60] bg-ink/70 backdrop-blur-sm"
          data-testid="quick-checkout-backdrop"
        />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[70] w-[calc(100%-3rem)] max-w-sm bg-coal border border-white/10 px-8 py-8"
          data-testid="quick-checkout-modal"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-ash hover:text-gold transition-colors duration-300"
            data-testid="quick-checkout-close"
            aria-label="Close checkout"
          >
            <X className="h-4 w-4" />
          </button>
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Complete your order</p>
          <p className="mt-3 font-serif text-2xl text-white" data-testid="quick-checkout-title">
            {title}
          </p>
          <div className="mt-6">
            <PayPalCheckout items={items} />
            <CardCheckout items={items} testid="quick-checkout-card-button" />
          </div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);
